import MagentoWishlistState from '../types/MagentoWishlistState'

const state: MagentoWishlistState = {
  loaded: false,
  loading: false,
  items: [],
  itemIds: {}
}

export default state
